module.exports = __webpack_public_path__ + "img/hero-dropdown-search-ford.02d90752.png";